import React, { useEffect, useState } from 'react';

import { useTypedSelector } from 'Libs/redux/utils';
import { useAppDispatch } from 'Libs/redux/store';

import { contentMetadataSelector, selectById } from 'Store/entities/content/content/content.selectors';
import { fetchContentById } from 'Store/entities/content/content/content.thunks';

import { SPageLoader } from 'Components/structural';

import { getContentId } from './contentEdition.utils';
import { ContentForm } from './ContentForm';

enum ContentDataStatus {
  WAITING_DATA,
  LOADING_DATA,
  LOADED_DATA,
}

export const ContentEdition = () => {
  const contentId = getContentId();
  const dispatch = useAppDispatch();

  const content = useTypedSelector(selectById(contentId));

  const [loading, setLoading] = useState<ContentDataStatus>(
    contentId ? ContentDataStatus.WAITING_DATA : ContentDataStatus.LOADED_DATA,
  );

  useEffect(() => {
    if (contentId) {
      dispatch(fetchContentById({ contentId }));
    }
  }, [contentId]);

  const { loading: requestLoading } = useTypedSelector(contentMetadataSelector);

  useEffect(() => {
    if (requestLoading && loading === ContentDataStatus.WAITING_DATA) {
      setLoading(ContentDataStatus.LOADING_DATA);
    }
    if (!requestLoading && loading === ContentDataStatus.LOADING_DATA) {
      setLoading(ContentDataStatus.LOADED_DATA);
    }
  }, [requestLoading]);

  if (loading !== ContentDataStatus.LOADED_DATA || !content) return <SPageLoader />;

  return <ContentForm content={content} />;
};
